var React = require('react');

function MoeShare (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FFF","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 .472v57.761h57.762V33.917h-5v19.317H5V5.472h18.827v-5z","key":0}),React.createElement("path",{"d":"M52.762 5.472v.26l-.26-.26h.26zm-19.43 0h15.895l-23.882 23.88 3.536 3.536 23.88-23.88v15.948h5V.472h-24.43v5z","key":1})]));
}

MoeShare.defaultProps = {"width":"58","height":"59"};

module.exports = MoeShare;

MoeShare.default = MoeShare;
